<template>
  <div class="buyer-supply">
    <el-dialog
      width="640px"
      align="center"
      title="批量改「买手组与买手」"
      :visible="visible"
      :before-close="closeBox"
    >
      <el-form :model="form">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <el-input
                v-model="form.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="选择买手组" align="left" required>
              <el-select
                v-model="form.pg_id"
                placeholder="请选择"
                filterable
                @change="getGroupMember"
              >
                <el-option
                  v-for="item in buyerGroups"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择买手" align="left" required>
              <el-select
                v-model="form.supply_picker_group_member_id"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in buyers"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBox">取 消</el-button>
        <el-button size="small" type="success" @click="submitData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
export default {
  name: 'BuyerBindSupply',
  props: {
    supplyIds: {
      type: Array,
      default: () => [],
    },
    visibleType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: true,
      form: { supply_picker_group_member_id: '', pg_id: '', supply_ids: "" },
      buyers: [],
      buyerGroups: []
    };
  },
  mounted() {
    this.fetchDataGroup()
  },
  methods: {
    fetchDataGroup() {
      this.$http
        .post("/erp/Common/selectPicker", { status: 1 })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.buyerGroups = result.data.data.map(e =>({ ...e, value: e.k }));
        })
        .catch(() => {});
    },
    getGroupMember(id) {
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: id })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.form.supply_picker_group_member_id = ""
          this.buyers = result.data.data;
        })
        .catch(() => {});
    },
    submitData() {
      const { supply_picker_group_member_id, pg_id, supply_ids: supplyIds } = this.form;

      // 校验是否有商家id
      if (supplyIds === "") {
        this.$message({
          showClose: true,
          message: "请输入商家ids~",
          type: "error",
        });
        return;
      }
      if (!pg_id) {
        this.$message({
          showClose: true,
          message: "请选择买手组~",
          type: "error",
        });
        return;
      }
      if (!supply_picker_group_member_id) {
        this.$message({
          showClose: true,
          message: "请选择买手~",
          type: "error",
        });
        return;
      }
      this.form.supply_ids = this.supplyIds;
      this.$http
        .post("/erp/Supply/batchUpdatePickerInfo", {
          pg_id,
          supply_picker_group_member_id,
          supply_ids: supplyIds.trim().split("\n"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            if (result.data.data && result.data.data.file) {
              window.open(apiBaseURL + result.data.data.file);
            }
            return;
          }
          this.$message.success("修改成功");
          this.closeBox();
        })
        .catch(() => {});
    },
    closeBox() {
      this.$emit("onCloseDialog", { visible: this.visibleType });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/BuyerBindSupply.vue